import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";

export default class Category extends Model {
    static entity = 'pages';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            title: this.string(''),
            code: this.string(''),
            meta_description: this.string(''),
            meta_url: this.string(''),
            content: this.string(''),

            created_at: this.string(''),
            updated_at: this.string(''),
        }
    }

    declare id: number;
    declare title: string;
    declare code: string;
    declare meta_description: string;
    declare meta_url: string;
    declare content: string;
}
